import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * ProgressThread, the 4px progress bar.
 *
 * CSS selector: `mobile/molecules.css` `.ds-progress`, with
 * `.ds-progress__fill`.
 *
 * Doctrine: the accent fill here is correct rather than an exception, because
 * progress is exactly the kind of state accent is rationed for. The only inline
 * style in this component is the fill width, which is data and carries no
 * colour, size or theme decision.
 *
 * Pass `value` with an optional `max`, or a raw `percent` that wins over both.
 */
export const ProgressThread = React.forwardRef(function ProgressThread(
  { className, value = 0, max = 100, percent, ...rest },
  ref,
) {
  const resolved = percent === undefined ? (value / max) * 100 : percent;
  const pct = Math.min(100, Math.max(0, resolved));

  return (
    <div
      ref={ref}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('ds-progress', className)}
      {...rest}
    >
      <span className="ds-progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
});

export default ProgressThread;
